import React, { useState, useEffect } from 'react';
import { WafoForm, WafoFormInput } from '@wafo/forms';
import axiosConfig from '#utils/axiosConfig';
import { useAlert } from 'react-alert';
import { Redirect } from 'react-router';

const EditProveedor = ({ location: { state } }) => {
	const [submitted, setSubmitted] = useState(false);
	const [defaultCarrier, setDefaultCarrier] = useState({});
	const alert = useAlert();

	useEffect(() => {
		const getCarrier = async () => {
			const carrierInfo = await axiosConfig({
				method: 'get',
				url: '/Data-System/Transportistas/getTransportista',
				params: { idTransportista: state.carrierId }
			});

			setDefaultCarrier({
				idTransportista: carrierInfo.Id_Transportista,
				transportista: carrierInfo.Nombre_Transportista
			});
		};
		if (state) {
			getCarrier();
		}
	}, [state]);

	const submitCarrier = async (form, values) => {
		if (form.valid) {
			try {
				const { data } = await axiosConfig({
					method: 'put',
					url: '/Data-System/Transportistas/Editar',
					data: values
				});

				if (data === 'OK') {
					alert.show(`El Transportista ${values.transportsista} fue editado correctamente.`, {
						type: 'success'
					});
					setSubmitted(true);
				}
			} catch (error) {
				alert.show('Hubo un problema editando al transportista, intentelo mas tarde.', {
					type: 'error'
				});
			}
		}
	};

	if (submitted) {
		return <Redirect to="/Data-System/Catalogos/Transportistas" />;
	}
	if (state) {
		if (!defaultCarrier) {
			return <div>Cargando</div>;
		}
		return (
			<div className="w-full lg:w-3/4 mx-auto bg-gray-100 shadow-md mt-4">
				<div className="flex flex-col w-full p-4 mb-4">
					<div className="flex flex-col items-center">
						<p className="text-2xl mt-2">Editar Transportista</p>
					</div>
					<WafoForm values={defaultCarrier} formId="editCarrierForm" onSubmit={submitCarrier}>
						<div className="flex flex-col mx-auto w-full lg:w-3/4 items-center">
							<div className="flex flex-col md:flex-row pr-2 md:pr-0">
								<WafoFormInput
									name="idTransportista"
									label="Id"
									placeholder="Id"
									extraProps={{
										disabled: true
									}}
								/>
								<WafoFormInput
									name="transportista"
									label="Nombre"
									placeholder="Nombre"
									customClass="form-group-lg"
									validations={{
										required: {
											value: true,
											message: 'El campo Nombre es requerido'
										}
									}}
								/>
							</div>

							<button className="button btn-lg bg-green-700 mt-3 mb-2">Editar Transportista</button>
						</div>
					</WafoForm>
				</div>
			</div>
		);
	}
	return <Redirect to="/Data-System/Catalogos/Transportistas" />;
};

export default EditProveedor;
